<template>
  <div>
    <v-dialog
      scrollable
      v-model="editDialog.show"
      persistent
      :max-width="$spec.dialog_standard_max_width"
    >
      <v-card>
        <v-card-title class="headline">編輯個人資訊</v-card-title>
        <v-card-text>
          <v-form ref="editForm">
            <v-text-field v-model="editDialog.name" :rules="editDialog.nameRules" label="姓名"></v-text-field>
            <v-text-field v-model="editDialog.phone" label="電話" disabled></v-text-field>
            <v-text-field
              label="密碼"
              class="overline"
              v-model="passwordSymbol"
              append-icon="mdi-shield-edit"
              readonly
              @click:append="showUpdatePasswordDialog"
            ></v-text-field>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="editDialog.show = false">取消</v-btn>
          <v-btn
            color="green"
            text
            @click="updateProfile"
            :loading="updatePasswordDialog.loading"
          >儲存</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="updatePasswordDialog.show"
      persistent
      :max-width="$spec.dialog_standard_max_width"
    >
      <v-card>
        <v-card-title class="headline">重設密碼</v-card-title>
        <v-card-text>
          <v-form ref="passwordForm">
            <v-text-field
              v-model="updatePasswordDialog.origin"
              :rules="updatePasswordDialog.originRules"
              :append-icon="
                updatePasswordDialog.showOrigin ? 'mdi-eye' : 'mdi-eye-off'
              "
              :type="updatePasswordDialog.showOrigin ? 'text' : 'password'"
              @click:append="
                updatePasswordDialog.showOrigin = !updatePasswordDialog.showOrigin
              "
              label="原密碼"
            ></v-text-field>
            <v-text-field
              v-model="updatePasswordDialog.new"
              :rules="updatePasswordDialog.newRules"
              :append-icon="
                updatePasswordDialog.showNew ? 'mdi-eye' : 'mdi-eye-off'
              "
              :type="updatePasswordDialog.showNew ? 'text' : 'password'"
              @click:append="
                updatePasswordDialog.showNew = !updatePasswordDialog.showNew
              "
              label="新密碼"
            ></v-text-field>
            <v-text-field
              v-model="updatePasswordDialog.again"
              :rules="updatePasswordDialog.againRules"
              :append-icon="
                updatePasswordDialog.showAgain ? 'mdi-eye' : 'mdi-eye-off'
              "
              :type="updatePasswordDialog.showAgain ? 'text' : 'password'"
              @click:append="
                updatePasswordDialog.showAgain = !updatePasswordDialog.showAgain
              "
              label="確認新密碼"
            ></v-text-field>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="updatePasswordDialog.show = false">取消</v-btn>
          <v-btn
            color="green"
            text
            @click="updatePassword"
            :loading="updatePasswordDialog.loading"
          >儲存</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
      top
      color="success text-center"
      class="subtitle-1"
      :timeout="$spec.snakebar_timeout"
      v-model="updatePasswordSnackbar"
      vertical
    >
      <span>密碼重設成功</span>
    </v-snackbar>
  </div>
</template>

<style scoped>
.v-snack--top {
  top: 40px;
}
</style>

<script>
export default {
  data: thisVm => ({
    passwordSymbol: "",
    updatePasswordSnackbar: false,
    editDialog: {
      show: false,
      phone: "",
      name: "",
      nameRules: [v => !!v || "請輸入姓名"],
      loading: false
    },
    updatePasswordDialog: {
      show: false,
      showOrigin: false,
      origin: "",
      originRules: [
        v => !!v || "請輸入原密碼",
        () => !thisVm.updatePasswordDialog.wrongPassword || "密碼錯誤"
      ],
      new: "",
      newRules: [
        v => !!v || "請輸入新密碼",
        v => (v && v.length >= 4) || "密碼長度需超過4個字元"
      ],
      showNew: false,
      again: "",
      againRules: [
        v => !!v || "請重新輸入密碼",
        v => (v && v.length >= 4) || "密碼長度需超過4個字元",
        () => {
          if (
            thisVm.updatePasswordDialog.new !==
            thisVm.updatePasswordDialog.again
          ) {
            return "密碼不一致";
          } else {
            return true;
          }
        }
      ],
      showAgain: false,
      loading: false,
      wrongPassword: false
    }
  }),
  methods: {
    async show(userProfile) {
      if (this.$refs.editForm) {
        this.$refs.editForm.reset();
        await this.$nextTick();
      }
      this.passwordSymbol = "●●●●●●●";
      this.editDialog.name = userProfile.name;
      this.editDialog.phone = userProfile.phone;

      this.editDialog.loading = false;
      this.editDialog.show = true;
    },
    async showUpdatePasswordDialog() {
      if (this.$refs.passwordForm) {
        this.$refs.passwordForm.reset();
        await this.$nextTick();
      }
      this.updatePasswordDialog.showOrigin = false;
      this.updatePasswordDialog.showNew = false;
      this.updatePasswordDialog.showAgain = false;
      this.updatePasswordDialog.wrongPassword = false;

      this.updatePasswordDialog.loading = false;
      this.updatePasswordDialog.show = true;
    },
    async updateProfile() {
      if (this.$refs.editForm.validate()) {
        this.editDialog.loading = true;
        await this.$ajax.put(
          `${this.$config.apiUrl}/${this.$my.getClinic()}/users/${
            this.editDialog.phone
          }`,
          {
            name: this.editDialog.name
          }
        );
        this.editDialog.show = false;
        this.editDialog.loading = false;
        this.$emit("done");
      }
    },
    async updatePassword() {
      if (this.$refs.passwordForm.validate()) {
        this.updatePasswordDialog.loading = true;
        let response = await this.$ajax.put(
          `${this.$config.apiUrl}/${this.$my.getClinic()}/staff/${
            this.editDialog.phone
          }`,
          {
            newPwd: this.updatePasswordDialog.again,
            oldPwd: this.updatePasswordDialog.origin
          }
        );

        this.updatePasswordDialog.loading = false;
        if (JSON.stringify(response.data) === "null") {
          this.updatePasswordDialog.wrongPassword = true;
          this.$refs.passwordForm.validate();
        } else {
          this.updatePasswordDialog.show = false;
          this.updatePasswordSnackbar = true;
        }
      }
    }
  }
};
</script>
